import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/park/user/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/park/user/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/park/user/remove/v2', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/user/save/v2', params, options);

export const update = (params, options) => request.post('/api/park/user/update/v2', params, options);

export const getPassages = param => {
  return request({
    url: '/api/park/user/passages/v2',
    method: 'get',
    params: {
      parkId: param,
    }
  });
};
